import * as TP from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCompanyQueryVariables = TP.Exact<{
  companyInput: TP.CompanyInput;
}>;


export type GetCompanyQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getCompany: (
    { readonly __typename?: 'CompanyDetail' }
    & Pick<TP.CompanyDetail, 'id' | 'name' | 'phoneNumber' | 'identifierType' | 'identifier'>
    & { readonly address: (
      { readonly __typename?: 'AddressDetail' }
      & Pick<TP.AddressDetail, 'id' | 'street1' | 'street2' | 'locality' | 'administrativeArea1Code' | 'administrativeArea2Code' | 'postalCode' | 'countryAlpha2Code'>
    ) }
  ) }
);


export const GetCompanyDocument = gql`
    query GetCompany($companyInput: CompanyInput!) {
  getCompany(companyInput: $companyInput) {
    id
    name
    phoneNumber
    identifierType
    identifier
    address {
      id
      street1
      street2
      locality
      administrativeArea1Code
      administrativeArea2Code
      postalCode
      countryAlpha2Code
    }
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      companyInput: // value for 'companyInput'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;